'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-76/node_modules/@eliadmin/core/src/components/contact/contact-form.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-76/node_modules/@eliadmin/core/src/components/contact/contact-form.tsx").ContactForm>>;
const Deferred = lazy(() => import("@eliadmin/module-original/contactForm").then(m => ({ default: m.ContactForm })));
export function ContactForm(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

